import { createContext, ReactNode, useEffect, useState } from 'react';
import { Themes } from '../constants/Themes';
import { useAuth } from '../hooks/useAuth';
import { api } from '../server/api';
interface ThemeContextProviderProps {
  children: ReactNode;
}
interface IParams {
  clientId?: string;
  playerId?: string;
}
interface ThemeContextProps {
  theme: string | undefined;
  propsTheme: any | undefined;
  toggleTheme: () => void;
}

export const themeContext = createContext({} as ThemeContextProps);

export function ThemeContextProvider(props: ThemeContextProviderProps) {
  const { client, setClient } = useAuth();
  const [theme, setTheme] = useState<string | undefined>('');
  const [propsTheme, setPropsTheme] = useState<any>();

  useEffect(() => {
    const pathname = location.pathname.split('/');
    const localTheme = localStorage.getItem('theme')?.replaceAll('"', '');

    // verifica se existe o tema definido
    // caso não tenha configura com o tema 'light'
    // verifica se o usuário acessou uma action
    if (theme) {
      setCSSVariables(propsTheme);
    } else {
      if (pathname[1] === 'action') {
        setTheme('light');
        if (pathname.length === 6) {
          getClientByUrl({ playerId: pathname[2], clientId: pathname[5] });
        } else {
          getClientByUrl({ playerId: pathname[2], clientId: pathname[4] });
        }
      } else {
        if (client) {
          const { primaryColor } = client;
          if (localTheme === 'dark') {
            Themes['dark'].primary = primaryColor;
            Themes['dark'].secondary = `${primaryColor}20`;
            Themes['dark'].primary_flat = `${primaryColor}`;
            Themes['dark'].secondary_flat = `${primaryColor}50`;
            setTheme('dark');
            setPropsTheme(Themes['dark']);
            setCSSVariables(Themes.dark);
          } else {
            Themes['light'].primary = primaryColor;
            Themes['light'].secondary = `${primaryColor}20`;
            Themes['light'].primary_flat = `${primaryColor}`;
            Themes['light'].secondary_flat = `${primaryColor}50`;
            setTheme('light');
            setPropsTheme(Themes['light']);
            setCSSVariables(Themes.light);
          }
        }
      }
    }
  }, [client]);

  const getClientByUrl = async ({ playerId, clientId }: IParams) => {
    const parameters = {
      searchFunctionality: 'getClientPublicData',
      userType: 'lead',
      playerId,
      clientId,
    };

    await api
      .post(`/clientPublicData`, parameters)
      .then((res) => {
        const { primaryColor } = res.data.data.clientData;

        Themes['light'].primary = primaryColor;
        Themes['light'].secondary = `${primaryColor}20`;
        Themes['light'].primary_flat = `${primaryColor}`;
        Themes['light'].secondary_flat = `${primaryColor}50`;

        setClient(res.data.data.clientData);
        setTheme('light');
        setPropsTheme(Themes['light']);
        setCSSVariables(Themes.light);
      })
      .catch((e) => console.log('error', e));
  };

  const setCSSVariables = (theme: any) => {
    for (const value in theme) {
      document.documentElement.style.setProperty(
        `--${value.replace('_', '-')}`,
        theme[value]
      );
    }
  };

  const toggleTheme = () => {
    const { primaryColor } = client;
    if (theme === 'light') {
      Themes['dark'].primary = primaryColor;
      Themes['dark'].secondary = `${primaryColor}20`;
      Themes['dark'].primary_flat = `${primaryColor}`;
      Themes['dark'].secondary_flat = `${primaryColor}50`;
      setTheme('dark');
      setPropsTheme(Themes['dark']);
      setCSSVariables(Themes.dark);
      localStorage.setItem('theme', JSON.stringify('dark'));
      localStorage.setItem('propsTheme', JSON.stringify(Themes['dark']));
    } else {
      Themes['light'].primary = primaryColor;
      Themes['light'].secondary = `${primaryColor}20`;
      Themes['light'].primary_flat = `${primaryColor}`;
      Themes['light'].secondary_flat = `${primaryColor}50`;
      setTheme('light');
      setPropsTheme(Themes['light']);
      setCSSVariables(Themes.light);
      localStorage.setItem('theme', JSON.stringify('light'));
      localStorage.setItem('propsTheme', JSON.stringify(Themes['light']));
    }
  };

  return (
    <themeContext.Provider value={{ theme, toggleTheme, propsTheme }}>
      {props.children}
    </themeContext.Provider>
  );
}
